import React, { Fragment} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveCharacter } from '../../../actions/character';

const CharEditMain = ({
    character: {
        character
    },
    saveCharacter
}) => {

    const {
        notes
    } = character;

    const generateNotes = () => {
        
        var noteElements = notes.map((note, index) => 
            <div className="charNoteContainer" key={index}>
                <textarea className="charNote" name='personality' value={note.noteText} cols="93" rows="10" onChange={e => onChange(index)(e)}></textarea>
                <div className="deleteNoteBut" onClick={e => deleteNote(index)(e)}>DELETE</div>
            </div>
        );

        return noteElements;
    }

    //Create new note
    const createNewNote = () => e => {
        var curNotes = [...notes];

        if(curNotes.length === 5){
            alert('You have reached the max number of notes');
            return;
        }

        var newNotes = [...curNotes, {noteText: ''}]

        saveCharacter({
            ...character,
            'notes': newNotes
        });
    }

    const deleteNote = (index) => e => {

        var curNotes = [...notes];

        curNotes.splice(index, 1);

        //console.log(notes.splice(index, 1));

        saveCharacter({
            ...character,
            'notes': curNotes
        })
    }

    //Update current note
    const onChange = (index) => (e) => {
        var newInput = {'noteText': e.target.value};

        var newNoteArray = [...notes];

        newNoteArray[index] = newInput;

        saveCharacter({
            ...character,
            'notes': newNoteArray
        });
    }

    console.log(notes)

    return (
        <Fragment>
            <div className="char-sheet-notes-panel">
                <h1 className="text-blue large">Notes</h1>
                {generateNotes()}
                <div className="newNoteButton" onClick={e => createNewNote()(e)}>NEW NOTE</div>
            </div>
        </Fragment>
    )
}

CharEditMain.propTypes = {
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(CharEditMain);
